import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { createContext } from "react";
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile } from "firebase/auth";
import app from "../firebase/firebase.init";

export const AuthContext = createContext();
const auth = getAuth(app);
const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [allData, setData] = useState([]);
	const [loading, setLoading] = useState(true)

	const handleSignIn = (provider) => {
		setLoading(true)
		return signInWithPopup(auth, provider);
	};

    const handleLogOut = () => {
		setLoading(true)
      return  signOut(auth)
    }
    const createUser = (email,pass) => {
		setLoading(true)
        return createUserWithEmailAndPassword(auth, email,pass)
    }
    const updateUserInfo = (profile) => {
        return updateProfile(auth.currentUser, profile)
    }
    const handleLoginEmailPass = (email, pass) => {
		setLoading(true)
       return signInWithEmailAndPassword(auth, email,pass)
    }
    	useEffect(() => {
			const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
				
					setUser(currentUser)
					setLoading(false)
				
			});
		return () => {
			unsubscribe();
		};
	}, []);

	useEffect(() => {
		fetch("https://assignment-10-server-rose-one.vercel.app/")
			.then((res) => res.json())
			.then((data) => setData(data))
			.catch((err) => console.log(err.message));
	}, []);

	const authInfo = { allData, handleSignIn, user,handleLogOut,createUser,updateUserInfo,handleLoginEmailPass, loading };
	return (
		<AuthContext.Provider value={authInfo}>{children}</AuthContext.Provider>
	);
};

export default AuthProvider;
